// import isApiError from "@insite/client-framework/Common/isApiError";
// import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
// import { AccountModel } from "@insite/client-framework/Types/ApiModels";

// import { post } from "@insite/client-framework/Services/ApiService";


// export interface propertyInformation {
//     name: string,
//     webAddress: string,
//     phoneNumber: string,
//     type: string,
//     otherPropertyType: string,
//     address: string,
//     cityAndState: string,
//     zip: any,
//     ownerName: string,
//     ownerPhoneNumber: string,
//     ownerAddress: string,
//     ownerCityAndState: string,
//     ownerZip: number,
//     ownerContact: string,
//     ownerEmail: string
// }

// export interface accounting {
//     name: string,
//     email: string,
//     phone: string
// }
// export interface TradeCreditReference {
//     companyName?: string,
//     contact?: string,
//     address?: string,
//     city?: string,
//     state?: string,
//     zip?: string,
//     phone?: string,
//     fax?: string,
//     accountNumber?: string,
// }

// export interface physicalAddress {
//     name: string,
//     email: string,
//     phone: string
// }

// export interface mailingAddress {
//     name: string,
//     email: string,
//     phone: string
// }


// export type TradeCreditReferences = TradeCreditReference[];
// export interface CreditFormDataParameter {

//     propertyInformation?: propertyInformation,
//     accounting?: accounting,
//     physicalAddress?: physicalAddress,
//     mailingAddress?: mailingAddress
//     managementCompany?: string,
//     managementCompanyPhoneNumber?: string,
//     epa?: string,
//     methodOfInvoicing?: [
//         string
//     ],
//     relationToPurchaser?: string,
//     ownedPropertySince?: number,
//     creditLimitRequested?: string,
//     legalName?: string,
//     phoneNumber?: string,
//     doingBussinessAsDBA?: string,
//     faxNumber?: string,
//     taxId?: string,
//     city?: string,
//     zip?: any,
//     emailAddress?: string,
//     webAddress?: string,
//     companyType?: string,
//     isPurchaseOrderRequired?: boolean,
//     isStatementRequired?: boolean,
//     isAuthorizedBuyer?: boolean,
//     authorizedBuyers?: string,
//     isTaxResale?: boolean,
//     contractorLicence?: string,
//     noOfEmployees?: number,
//     dateOfEstablishment?: string,
//     nameOfPurchaser?: string,
//     namePrinted?: string,
//     title?: string,
//     date?: string,
//     tradeCreditReferences?: TradeCreditReferences,
//     taxExempFile?: any
// }

// const customCreditFormUrl = "/api/v2/email/multifamilycreditapplication";

// export function multiFamilCreditFormService(parameter: CreditFormDataParameter) {
//     return post<CreditFormDataParameter>(customCreditFormUrl, parameter);
// }


import { ApiParameter, del, get, post, request } from "@insite/client-framework/Services/ApiService";
import { MultiFamilyCreditFormModel } from "@tFissco/ApiModels";


const customMultiFamilyCreditFormUrl = "/api/v2/email/multifamilycreditapplication";

export async function getCreditFormFields() {
    try {
        const fieldCollection = await get<MultiFamilyCreditFormModel[]>(customMultiFamilyCreditFormUrl, {})
            .then(response => {
                return response;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error("Console error", err);
            });
        return fieldCollection;
        // eslint-disable-next-line no-empty
    } catch (error) { }
}

export function addCreditFormFields(parameter: MultiFamilyCreditFormModel) {
    const formData = new FormData();
    formData.append("creditrequest", JSON.stringify(parameter));

    if (parameter?.taxExempFile !== null && parameter?.taxExempFile !== "") {
        formData.append("taxExempFile", parameter?.taxExempFile || null);
    }

    return request<MultiFamilyCreditFormModel>(customMultiFamilyCreditFormUrl, "POST", {}, formData);
}



